import { Box, StackView, useViewport } from "@telus-uds/components-base";

const MainContentWrapper = ({ children, id }) => {
  const viewport = useViewport();

  return (
    <Box space={4} flex={1} variant={{ background: "lightest" }} scroll>
      <StackView
        space={4}
        direction="column"
        tokens={{
          justifyContent: "space-between",
          flexGrow: 1,
        }}
        id={id}
      >
        {children}
      </StackView>
    </Box>
  );
};

export default MainContentWrapper;
